import React from 'react';
import { OutcomeText } from '../../services/bidOutcome';

/**
 * The visible result of a bid attempt (see services/bidOutcome.ts). Stays on screen until the
 * bidder dismisses it or bids again — a refusal that vanishes in three seconds reads as a glitch.
 */
const TONE: Record<OutcomeText['tone'], string> = {
  success: 'bg-green-50 border-green-300 text-green-900',
  info: 'bg-blue-50 border-blue-300 text-blue-900',
  closed: 'bg-gray-100 border-gray-400 text-gray-900',
  refused: 'bg-amber-50 border-amber-300 text-amber-900',
  pending: 'bg-yellow-50 border-yellow-300 text-yellow-900',
  error: 'bg-red-50 border-red-300 text-red-900',
};

export const BidOutcomeNotice: React.FC<{ outcome: OutcomeText | null; onDismiss?: () => void; className?: string }> = ({ outcome, onDismiss, className = '' }) => {
  if (!outcome) return null;
  return (
    <div role="alert" aria-live="assertive" className={`border rounded px-3 py-2 text-sm ${TONE[outcome.tone]} ${className}`}>
      <div className="flex items-start justify-between gap-2">
        <p className="font-semibold">{outcome.title}</p>
        {onDismiss && (
          <button type="button" onClick={onDismiss} aria-label="Dismiss" className="text-current opacity-60 hover:opacity-100 leading-none">×</button>
        )}
      </div>
      <p className="mt-0.5">{outcome.text}</p>
    </div>
  );
};

export default BidOutcomeNotice;
